const message = {
    company: "Perusahaan",
    department: "Departemen",
    directorate: "Direktorat",
    division: "Divisi",
    employee: "Karyawan",
    functional: "Functional",
    grade: "Golongan",
    jobStatus: "Status Kerja",    
    lookup: "Lookup",
    position: "Posisi",
    section: "Section",
    superior: "Approval (Atasan)",
    unit: "OU (Unit)",
    user:"User",
    group: "Group",
    menu: "Menu",
    role: "Role",    
    business: "Bisnis",   
    region: "Region", 
    active: "Aktif",   
    name6up: "Nama (Grade 6Up)",
    fortable: "Fortable",
    rank: "Pangkat",
    birthdate: "Tanggal Lahir",
    workdate: "Tanggal Mulai Bekerja",    
    superior1: "Superior",
    nik_superior1: "NIK Superior",    
    superior2: "Head Superior",
    nik_superior2: "NIK Head Superior",    
    pic: "Nama PIC",    
    inactive_account: "Akun ini tidak aktif",   
    receive_notification: "Terima Pemberitahuan",    
    appraisal_year: "Tahun Penilaian",
    appraisal: "Penilaian",    
    employee_data: "Data Karyawan",    
    emp_name: "Nama Karyawan",
    EPA: "Penilaian Kinerja Karyawan",    
    warning_letter_period: "Surat Peringatan (Efektif)",
    appraisal_period: "Periode Penilaian",
    comment_review: "Komentar Penilai",    
    company_name: "Nama Perusahaan",    
    company_desc: "Nama Lengkap Perusahaan",
    dept_name: "Nama Departemen",    
    directorate_name: "Nama Direktorat",    
    division_name: "Nama Divisi",    
    functional_name: "Nama Functional",    
    business_unit: "Business Unit",    
    ou_name: "Nama OU",    
    region_code: "Kode Region",   
    period_History: "Tahun Periode",  
    cut_off: "Cut Off",
    valid_from: "Valid Dari",
    valid_to: "Valid Sampai",
    semester: "Semester",
    pembobotan: "Pembobotan",    
    rating: "Bobot",    
    total_score: "Score Akhir",   
    objective: "Sasaran & Ukuran Keberhasilan",
    achieve: "Pencapaian",
    evaluate: "Evaluasi & Feedback",
    point: "Nilai",    
    job_status_name: "Nama Status Kerja",    
    section_name: "Nama Section",   
    position_name: "Nama Posisi",   
    name: "Nama",
    year: "Tahun",
    s_edit: "Edit By Superior",
    s_date: "Edit Date Superior",    
    h_edit: "Edit By H. Superior",
    h_date: "Edit Date H. Superior",        
    company_all: "Semua Perusahaan",
    functional_all: "Semua Functional",
    grade_all: "Semua Grade",
    unit_all: "Semua Unit",
    warning_letter: "SP (Surat Peringatan)",
    status_sp: "Status SP",
    period_sp: "Periode (Tanggal Mulai SP)",
    appraisal_reset: "Appraisal Data (Reset Penilaian)",    
    input_by: "Dibuat Oleh (User)",
    input_date: "Tgl. Pembuatan (User)",
    edit1_by: "Diubah Oleh (Superior)",
    edit1_date: "Tgl. Pengubahan (Superior)",
    edit2_by: "Diubah Oleh (Head Superior)",
    edit2_date: "Tgl. Pengubahan (Head Superior)",
    edit3_by: "Diubah Oleh (Komite)",
    edit3_date: "Tgl. Pengubahan (Komite)",    
    emp_number: "ID Karyawan",
    code: "Kode",
    description: "Deskripsi",            
    nik: "NIK",
    name: "Nama",
    created_by: "Dibuat Oleh",
    created_date: "Tgl. Pembuatan",
    edited_by: "Diubah Oleh",
    edited_date: "Tgl. Pengubahan",
    deleted_by: "Dihapus Oleh",
    deleted_date: "Tgl. Penghapusan",    
    is_deleted: "Hapus",
    rate: "Rate Akhir",
    period: "Period",    
    action: "Aksi",
    reset_confirmation: "Konfirmasi Reset",    
    promot_confirmation: "Konfirmasi Promosi",
    review_confirmation: "Konfirmasi Review",
    assesed_appraisal: "Daftar karyawan yang telah dinilai (Appraisal)",
    not_assesed_appraisal: "Daftar karyawan yang belum dinilai (Appraisal)",
    changelog: "Changelog",
    email: "Email",    
    username: "Username",
    full_name: "Nama",
    account: "Akun",    
    is_required: "Value diperlukan",   
    year: "Tahun",    
    create: "Create",    
    password: "Password",
    log_history: "Log Activity Penilaian (History)",    
    lookup_group: "Lookup Group",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    lookup_info1: "Info 1",
    lookup_info2: "Info 2",    
    version: "Versi",
    version_date: "Tanggal Versi",
    remark: "Keterangan",
    version_active: "Aktif Versi",    
    report_type: "Tipe Report",    
    ChangeOnTransaction: "Mengganti di transaksi ?",    
    userExc: "Pengecualian User",    
    clear: "Hapus",
    download_supporting_data: "Download Data Pendukung",
    use_ad: "Memiliki AD",
    create_appraisal_notice: "Untuk create data penilaian baru,",
    click_here: "Klik disini",
    criteria: "Kriteria",
    range: "Jangkauan",
    standard: "Standar",
    summary: "Ringkasan",    
    grade_begin: "Tanggal Mulai Golongan",    
    education: "Pendidikan",
    source: "Sumber",
    structure: "Deskripsi Struktur",    
    promotion_data: "Promotion Data",
    promotion_request: "Permintaan Promosi",
    tolerance_up: "Toleransi Atas",
    tolerance_down: "Toleransi Bawah",    
    promotion_status: "Permintaan Promosi",
    sync_confirmation: "Konfirmasi Sync",    
    score: "Score",
    status: "Status",
    lengthWork: "Masa Jabatan",
    lengthGrade: "Periode Golongan",  
    requested_date: "Tgl. Permintaan",    
    requested_by: "Diminta Oleh",    
    requester: "Permintaan",    
    hrr: "HRR/PGA Head",
    effective_date: "Tgl. Efektif",   
    reason: "Alasan",    
    new_position: "Posisi Baru",    
    reason_promot: "Alasan Promosi" ,  
    information: "Informasi",    
    promotion: "Promosi",    
    performance_period: "Periode Kinerja",
    nik_length: "NIK harus terdiri dari minimal 8 digit",
    sap_result_success: "dari total karyawan berhasil di sync",
    sap_result_failed: "dari total karyawan gagal di sync",    
    create_date: "Tanggal Dibuat",
    dept_div_name: "Nama Departemen & Divisi",
    summary_rate: "Ringkasan (Rating)",    
    appraisal_type: "Tipe Penilaian",
    grade_type: "Tipe Golongan",
    org_unit: "Unit Organisasi",
    disclaimer_promotion1: "Pengajuan promosi melalui sistem PES ini masih bersifat rekomendasi yang akan diverifikasi oleh Management Unit masing-masing.",
    disclaimer_promotion2: "Dan mengacu kepada persyaratan kualifikasi dalam Kebijakan Perusahaan mengenai promosi.",    
    min2year: "Minimal 2 tahun",
    spminKP: "Data SP diambil dalam periode penilaian saat ini",
    educationminKP: "Standar pendidikan akan disesuaikan dengan posisi yang dituju",
    positionminKP: "Pengajuan promosi mengacu kepada ketersediaan posisi",    
    employee_type: "Tipe Karyawan",    
    otp_msg: "Masukkan 6 Digit OTP",    
    locked_score: "Konfirmasi Tampilan",
    locked_score_msg: "Penilaian sudah dikunci dan tidak dapat dilakukan perubahan lagi",
    remark_255: "Keterangan (Maksimal 255 karakter)",   
    remark_1000: "Keterangan (Maksimal 1000 karakter)",       
    auth_report: "Jika ingin mengetahui detail otorisasi data yang anda miliki, silahkan",
    click_here: "klik disini!",    
    action_role: "Role Aksi",    
    promotbysuperior: "Promosi oleh Superior",
    emp_data: "Data Karyawan (Periode)",    
    display_confirm: "Tampilan Pemberitahuan",
    role_change_msg: "Evaluasi penilaian ini akan disimpan sebagai penilaian Perubahan Action Role.",
    change_confirm: "Apakah anda yakin untuk mengubahnya ?",    
    default_jobstatus: "Hasil yang digenerate di exclude PHK, Expatriate & Terminasi",
    export_type: "Tipe Export",
    trans_menu: "Menu Transaksi",
    committee: "Komite",    
    assessed_by: "Dinilai Oleh",
    approved_by: "Disetujui Oleh",
    approved_date: "Tanggal yang Disetujui",   
    rejected_by: "Ditolak Oleh",
    rejected_date: "Tanggal yang Ditolak",          
    signature_reviewee: "Tanda tangan orang yang ditinjau",
    signature_reviewer: "Tanda Tangan Peninjau",
    name_and_date: "Nama & Tanggal",
    confirm_Save: "Apakah yakin dengan jawaban kamu ?",
    method_id: "ID",
    method_name: "Nama Metode",
    func_layer: "Layer Fungsi",
    func_Percent: "Fungsi (%)",
    method_func: "Fungsi Metode", 
    nik_functional: "NIK Functional",       
    question_eng: "Soal (EN)",
    question_ind: "Soal (ID)",    
    col_area: "Area Kolom",
    loop_total: "Total Loop",
    question_procedure: "Prosedur Pertanyaan",
    questions: "Pertanyaan",
    question_details : "Detail Pertanyaan",
    actions: "Aksi",
    score_superior: "Score Oleh Superior",
    rate_superior: "Rate Oleh Superior",
    score_head_superior: "Score Oleh Head Superior",
    rate_head_superior: "Rate Oleh Head Superior",    
    score_functional: "Score Oleh Functional",
    rate_functional: "Rate Oleh Functional",
    sub_rate: "Sub Rate",
    use_sub_range : "Gunakan Sub Rate",    
    appraisal_data: "Data Penilaian",

    message:{
        reset_confirmation: "Apakah data penilaian ingin di reset",
        approve_confirmation: "Apakah data promosi ingin di approve",
        reject_confirmation: "Apakah data promosi ingin di reject",        
        sync_confirmation: "Apakah anda yakin ? Data penilaian yang dipilih ini akan dikirm ke HCM (Maksimal 100 data dikirim per batch).",
        sync_all_confirmation: "Apakah anda yakin untuk mengirim semua data penilaian ke SAP HCM ?",
        sync_no_data: "Tidak ada data yang dapat di sync (sumber HCM dan status tidak sama dengan SYNC TO HCM)",
        sync_promot_confirmation: "Apakah anda yakin ? Data promosi berikut akan dikirim ke Fiori (Maksimal 100 data dikirim per bacth).",
        select_score: "Silakan Pilih Skor Penilaian:",
        functional_not_assess: "Head Functional belum melakukan review"        
    },

    note: {
        history: "Catatan : Data penilai diurutkan dari bawah ke atas (Data paling atas adalah data terbaru). Dapat dilihat dari tanggal dan jam pada kolom 'Input Date'",
        mydata: "Catatan : Baris yang diwarnai hijau adalah karyawan yang penilaiannya sudah dinilai oleh Komite",
        listAssed: "Catatan untuk Admin Unit : Untuk penilaian karyawan yang sudah di-edit atau di-upload oleh Admin HO, maka tombol edit tidak tersedia di kolom karyawan tsb",
        employee: "Catatan : karyawan yang ditampilkan adalah karyawan yang bukan PHK/Terminasi/Expatriat, join diatas/melewati tanggal 1 Juli- Tahun dan gol 10- yakni direktur",
        reset: "Catatan : Data yang di reset adalah data penilaian terakhir !",
        last_reset: "Catatan : Pengaturan ulang ini akan menghapus semua data penilaian !",        
        cancel_promot: "Jika anda membatalkan permintaan promosi ini, anda masih dapat memintanya lagi di SAP Fiori",
        upload: " boleh digandakan dan boleh memasukkan kode baru. Jika kode sudah ada (duplikat), maka data sebelumnya akan diperbaharui",
        promote: "Catatan : Request Promosi yang akan di sync adalah request promosi pada tahun berjalan.",
        sync_hcm: "Hasil penilaian yang akan di sync adalah hasil penilaian pada tahun berjalan.",
        sp: "Catatan : SP (Surat Peringatan) yang ditampilkan adalah data SP yang terbit pada penilaian tahun berjalan",
        create_appraisal: "Catatan : Apabila terdapat Superior / Head Superior yang tidak sesuai maka silahkan dapat langsung disesuaikan dengan diubah sebelum lanjut ke proses penilaian."
    }
}

export default message;